import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeToTidal}
            sections={<PairSyncGuideContent sourceKey="youtube" destKey="tidal" />}
        />
    );
}
